import dayjs from "dayjs"

import isSameOrBefore from "dayjs/plugin/isSameOrBefore"
import isSameOrAfter from "dayjs/plugin/isSameOrAfter"

import { deburr, snakeCase } from "lodash-es"

dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)

export const matchTimeRanges = (hours) => {
  const now = dayjs() // Current time
  const day = now.day() // 0 (Sun) - 6 (Sat)

  if (!hours[day]) return false

  return hours[day].some(({ start_time, end_time }) => {
    // Parse the current time, start_time, and end_time as "HH:mm"
    const startTimeObj = dayjs(now)
      .hour(dayjs(start_time).hour())
      .minute(dayjs(start_time).minute())
      .subtract(15, "minute") // Adjust for inclusive start time
    const endTimeObj = dayjs(now)
      .hour(dayjs(end_time).hour())
      .minute(dayjs(end_time).minute())
      .add(15, "minute") // Adjust for inclusive end time

    // Compare the times
    return startTimeObj.isSameOrBefore(now) && endTimeObj.isSameOrAfter(now)
  })
}

export const buildDisabledConfig = (ranges) => {
  const disabledHours = []
  const disabledMinutes = {}

  const allHours = Array.from({ length: 24 }, (_, i) => i)
  const allowedHours = new Set()

  ranges.forEach(({ start_time, end_time }) => {
    const start = dayjs(start_time)
    const end = dayjs(end_time)

    for (let h = start.hour(); h <= end.hour(); h++) {
      allowedHours.add(h)
    }
  })

  // All hours that are not inside any open range = disabled
  allHours.forEach((h) => {
    if (!allowedHours.has(h)) disabledHours.push(h)
  })

  // Boundary minutes inside allowed hours
  ranges.forEach(({ start_time, end_time }) => {
    const start = dayjs(start_time)
    const end = dayjs(end_time)

    const startHour = start.hour()
    const endHour = end.hour()

    if (!disabledMinutes[startHour]) disabledMinutes[startHour] = []
    for (let m = 0; m < start.minute(); m++) {
      disabledMinutes[startHour].push(m)
    }

    if (!disabledMinutes[endHour]) disabledMinutes[endHour] = []
    for (let m = end.minute() + 1; m < 60; m++) {
      disabledMinutes[endHour].push(m)
    }
  })

  return { disabledHours, disabledMinutes }
}

export const days = [
  "So/Sun",
  "Mo/Mon",
  "Di/Tue",
  "Mi/Wed",
  "Do/Thu",
  "Fr/Fri",
  "Sa/Sat",
]

export const generateKey = (name) => {
  // 1️⃣ Remove accents/diacritics
  const deburred = deburr(name) // "Cafe Deja Vu!"

  // 2️⃣ Remove special characters except letters/numbers/spaces
  const cleaned = deburred.replace(/[^a-zA-Z0-9 ]/g, "") // "Cafe Deja Vu"

  // 3️⃣ Convert to snake_case
  const key = snakeCase(cleaned)

  return key.toLowerCase()
}
